import { useState, useEffect } from "react"
import API from "../../services/API"
import Grid from "../Tools/Grid"
import Avatar from "../Tools/Avatar"
import moment from "moment"
import { Link } from "react-router-dom"
import { Link as A } from "@mui/material"
import { txt } from "../../services/translation"

export default function Enrollments(){

    const [data, setData] = useState(null)

    useEffect(() => {

        API.get('/companies/me/enrollments')
            .then(r => setData(Array.isArray(r.data) ? r.data : []))

    }, [])

    return (

        <Grid 
            id='companyEnrollmentsGrid'
            columns={columns}
            rows={data}
            toolbar
        />

    )
}


const columns = [
    {
        field: 'createdAt',
        headerName: txt('registeredOn'),
        type: 'date',
        width: 120,
        aggregable: false,
        valueGetter: i => moment(i.row.createdAt).toDate(),
        renderCell: i => !i.rowNode.isAutoGenerated &&
            moment(i.value).format('L')
    },
    {
        field: 'course',
        headerName: txt('course'),
        width: 400,
        aggregable: false,
        valueGetter: i => i.row.course?.title
    },
    {
        field: 'avatar',
        headerName: txt('avatar'),
        width: 50,
        aggregable: false,
        valueGetter: i => i.row.user?.id,
        renderCell: i => !i.rowNode.isAutoGenerated &&
            <Link to={`/company/contacts/${i.value}`}>
                <Avatar 
                    initials={i.row.user?.initials} 
                    color={i.row.category?.color || 'grey'} 
                    size={36} 
                />
            </Link>
    },
    {
        field: 'user',
        headerName: txt('user'),
        width: 200,
        aggregable: false,
        valueGetter: i => i.row.user?.name
    },
    {
        field: 'completion',
        headerName: txt('completion'),
        type: 'number',
        width: 120,
        valueGetter: i => i.row.completion || 0,
    },
    {
        field: 'type',
        headerName: txt('type'),
        width: 190,
        aggregable: false,
        valueGetter: i => i.row.type?.title
    },
    {
        field: 'amount',
        headerName: txt('amount'),
        type: 'number',
        width: 100,
        valueGetter: i => i.row.amount || 0,
    },
    {
        field: 'email',
        headerName: txt('email'),
        width: 250,
        aggregable: false,
        valueGetter: i => i.row.user?.email,
        renderCell: i => <A href={`mailto:${i.value}`}>{i.value}</A>
    },
    {
        field: 'phone',
        headerName: txt('phone'),
        width: 120,
        aggregable: false,
        valueGetter: i => i.row.user?.phone,
        renderCell: i => <A href={`tel:${i.value}`}>{i.value}</A>
    },
    {
        field: 'address',
        headerName: txt('address'),
        width: 300,
        aggregable: false,
        valueGetter: i => i.row.user?.address
    },
    {
        field: 'zip',
        headerName: txt('zipCode'),
        width: 90,
        aggregable: false,
        valueGetter: i => i.row.user?.zip
    },
    {
        field: 'city',
        headerName: txt('city'),
        width: 150,
        aggregable: false,
        valueGetter: i => i.row.user?.city
    },
];